import React, { Component } from 'react';
import PropTypes from 'prop-types';
import IndexAndViewer from '../shared/IndexAndViewer';
import SingleDatasetReportsContainer from './SingleDatasetReportsContainer';

export default class DataReportsPage extends Component {
  static propTypes = {
    activeLink: PropTypes.number,
    datasets: PropTypes.object.isRequired,
    handleDatasetSelect: PropTypes.func.isRequired,
    selectedDataset: PropTypes.object,
    selectedDatasetId: PropTypes.number,
    versionsSummary: PropTypes.object,
  };

  static defaultProps = {
    activeLink: null,
    selectedDataset: null,
    selectedDatasetId: null,
    versionsSummary: null,
  };

  renderSingleDatasetReportsContainer = () => {
    const { selectedDataset, selectedDatasetId, versionsSummary } = this.props;

    return (
      <SingleDatasetReportsContainer
        dataset={selectedDataset}
        datasetId={selectedDatasetId}
        isIndexItem
        versionsSummary={versionsSummary}
      />
    );
  };

  render() {
    const { activeLink, datasets, handleDatasetSelect } = this.props;

    const datasetsWithVersions = datasets.map(dataset => {
      if (dataset.versionInfoList.size > 0) {
        return dataset;
      }
      return null;
    });

    return (
      <div className="modal-wrap">
        <div className="container-fluid container-home">
          <div className="header">
            <div className="header-body">
              <div className="row">
                <div className="col-sm-12">
                  <h1 className="header-title">Data Reports</h1>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              {datasets.size === 0 ? (
                <p>Your account is not associated with any datasets.</p>
              ) : (
                <IndexAndViewer
                  activeLink={activeLink}
                  list={datasetsWithVersions}
                  content={this.renderSingleDatasetReportsContainer()}
                  handleSelect={handleDatasetSelect}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
